import React from "react";

const EditIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 23.7177V11.4034C4 8.47505 6.36567 6.10938 9.28121 6.10938H12.299"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M21.6083 14.918V19.8156C21.6083 21.9638 19.8564 23.7157 17.7082 23.7157H8.80811"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M11.0332 13.1016L14.1917 16.2601"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M17.7082 6.45348L20.8667 9.70148L14.1789 16.2614L9.81836 17.6808L11.0204 13.1029L19.0637 5.09801C19.9332 4.24125 21.327 4.24125 22.1838 5.1108L23.8334 6.78595"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default EditIcon;
